import { z } from "zod";
import { type UUID, uuidv4 } from "../../../../../utils/uuid";

const customAnswerType = z.object({
  type: z.literal("custom"),
  alignment: z.enum(["horizontal", "vertical"]).default("horizontal"),
  button_type: z.enum(["primary_button", "secondary_button"]).default("primary_button"),
});

const presetAnswerType = z.object({ type: z.literal("preset"), variation: z.string() });

const pollSchema = z.object({
  id: z
    .uuid()
    .transform((val) => val as UUID)
    .default(uuidv4),
  question: z.string().min(1, { message: "Question is required" }),
  options: z
    .array(
      z.object({
        text: z.string().min(1, { message: "Option text is required" }),
      }),
    )
    .min(1, { message: "Options are required" })
    .refine(
      (items) => {
        return new Set(items.map((item) => item.text)).size === items.length;
      },
      {
        message: "All options must be unique, no duplicate values allowed",
      },
    ),
  answer_type: z.discriminatedUnion("type", [customAnswerType, presetAnswerType]),
  helper_text: z.string().optional().nullable(),
  show_poll_results: z.boolean().default(false),
});

export const pollWrapperSchema = z.object({
  poll: pollSchema,
  question_type: z.discriminatedUnion("type", [
    z.object({ type: z.literal("custom") }),
    z.object({ type: z.literal("preset"), variation: z.string() }),
  ]),
});

export type PollSchema = z.infer<typeof pollSchema>;

export type PollWrapperSchema = z.infer<typeof pollWrapperSchema>;
